<template>
  <div class="tcr">
    <button
      v-for="t in options"
      :key="t.id"
      class="tcr__chip"
      :class="{ 'tcr__chip--active': modelValue === t.id, 'tcr__chip--paused': t.acceptingTickets === false }"
      :title="t.acceptingTickets === false ? 'Marcó que no acepta tickets por ahora' : ''"
      @click="$emit('update:modelValue', modelValue === t.id ? null : t.id)"
    >
      <span class="tcr__avatar" :style="{ background: AVATAR_COLORS[t.avatarColor] || t.avatarColor }">{{ initials(t.name) }}</span>
      <span class="tcr__name">{{ t.name }}</span>
      <span v-if="t.acceptingTickets === false" class="tcr__pause">En pausa</span>
      <span v-else class="tcr__dot" :class="capacityClass(t.capacityPercent)"></span>
    </button>
  </div>
</template>

<script setup>
defineProps({ modelValue: { type: String, default: null }, options: { type: Array, default: () => [] } })
defineEmits(['update:modelValue'])

const AVATAR_COLORS = { blue: '#3b82f6', green: '#10b981', violet: '#8b5cf6', orange: '#f97316', teal: '#14b8a6', pink: '#ec4899', indigo: '#6366f1', amber: '#f0a500' }
function initials(name) { return name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase() }
function capacityClass(pct) { return pct >= 85 ? 'tcr__dot--red' : pct >= 60 ? 'tcr__dot--amber' : 'tcr__dot--green' }
</script>

<style scoped>
.tcr { display: flex; gap: 0.5rem; overflow-x: auto; padding-bottom: 0.2rem; }
.tcr__chip { display: flex; flex-direction: column; align-items: center; gap: 0.2rem; background: none; border: 1px solid transparent; border-radius: 8px; padding: 0.3rem; cursor: pointer; flex-shrink: 0; }
.tcr__chip--paused { opacity: 0.6; }
.tcr__pause { font-family: var(--font-body); font-size: 8px; font-weight: 600; color: #b45309; background: #fef3c7; border-radius: 6px; padding: 0 4px; }
.tcr__chip--active { border-color: #3b82f6; background: #eff6ff; }
.tcr__avatar { width: 24px; height: 24px; border-radius: 50%; color: #ffffff; font-size: 9px; font-weight: 600; display: flex; align-items: center; justify-content: center; }
.tcr__name { font-family: var(--font-body); font-size: 9px; color: #1e3a5f; max-width: 50px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tcr__dot { width: 6px; height: 6px; border-radius: 50%; }
.tcr__dot--green { background: #10b981; }
.tcr__dot--amber { background: #f0a500; }
.tcr__dot--red { background: #e84545; }
</style>